/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SubmitAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaModalFooterAction from 'DesignSystem/TysiaModal/TysiaModalFooter/TysiaModalFooterAction/index'



/** @type {import('Simple/types.js').View} */
export default function SubmitAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/Contracts/Content/Payor/Content/SignAction/Content/Content/CancelAction/Content/SubmitAction",
  onSubmit,
  isSubmitting
  
}) {
let cancelSignatureRequestSubmitData = fromData.useDataSubmit({ viewPath,
context: 'cancel_signature_request',
})
let cancelSignatureRequestIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'cancel_signature_request',
})
  return (<React.Fragment
>
<TysiaModalFooterAction
  viewPath={`${viewPath}/TysiaModalFooterAction`}
 size="normal"
 type="danger"
 data="cancel_signature_request"
 onClick={cancelSignatureRequestSubmitData}
 disabled={cancelSignatureRequestIsSubmittingData}
 text="Cancel signature request"
/>
{children}
</React.Fragment>)
}